import { format } from 'date-fns'
import React, { CSSProperties } from 'react'
import { FiCalendar, FiX } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import DatePicker from '../../../containers/BookingCalendar/FilterBar/DatePicker'
import NewDatePicker from '../DatePicker/DatePicker'
import { dateFormat } from '../../../utils/DateFormat'
import { Input } from '../elements'
import FormElement from '../FormElement'
import { IFormElementProps } from '../FormElement/FormInput'

const DateInput = FormElement(
  ({
    name,
    onChange,
    value,
    className,
    placeholder,
    isSelected,
    errorMsg,
    warningMsg,
    onFocus,
    onBlur,
    required,
    disabled,
    changeDateOnDisable,
    sized,
    size = 1,
    formatDate,
    offsetTop,
    offsetLeft,
    sizedOnMobile,
    disableMobileResizing,
    isSmallReservation,
    selectedDay,
    withEmptyOnStart,
    isClear,
    isCenterOnMobile,
    isWithError,
    startDate = new Date(),
    newDatePicker = false,
    pickerStyle,
  }: IDateInputProps) => {
    const [show, toggleShow] = React.useState(false)
    const anchor = React.useRef()

    function blur() {
      toggleShow(false)
      if (onBlur && changeDateOnDisable) {
        onBlur(value)
      }
      // if (onBlur) {
      //   onBlur(undefined)
      // }
    }

    function showDatePicker() {
      toggleShow(true)
    }

    function dateChange(date) {
      onChange(date)
    }

    function dateClear(e) {
      toggleShow(false)
      e.stopPropagation()
      onChange('')
    }

    React.useEffect(() => {
      document.addEventListener('touchmove', function() {
        toggleShow(false)
      })
      window.addEventListener('resize', function() {
        toggleShow(false)
      })
      return () => {
        document.removeEventListener('touchmove', function() {
          toggleShow(false)
        })
        window.removeEventListener('resize', function() {
          toggleShow(false)
        })
      }
    })

    return (
      <React.Fragment>
        <Flex
          justifyEnd={true}
          alignCenter={true}
          style={{ position: 'relative', zIndex: isCenterOnMobile ? 10 : 100 }}
          full={true}
          ref={anchor}
        >
          <Input
            name={name}
            placeholder={placeholder}
            selected={isSelected}
            error={errorMsg && errorMsg !== ''}
            warning={warningMsg && warningMsg !== ''}
            type={'text'}
            onFocus={onFocus}
            onChange={onChange}
            size={size}
            isWithError={isWithError ? !!errorMsg : false}
            onClick={!show ? showDatePicker : null}
            required={required}
            smallReservation={isSmallReservation}
            value={
              value
                ? format(
                    value,
                    dateFormat(formatDate ? formatDate : 'dd/MM/yyyy'),
                  )
                : !withEmptyOnStart
                ? startDate
                  ? format(
                      startDate,
                      dateFormat(formatDate ? formatDate : 'dd/MM/yyyy'),
                    )
                  : ''
                : ''
            }
            disabled={disabled}
            className={className}
            readOnly={true}
            style={{ background: 'transparent', cursor: 'pointer' }}
          />

          <Flex
            style={{
              pointerEvents: 'none',
              position: 'absolute',
              right: `${10 * size}px`,
            }}
            onClick={showDatePicker}
          >
            {isClear && value > 0 ? (
              <FiX
                size={18 * size}
                style={{
                  cursor: 'pointer',
                  marginRight: '3px',
                  opacity: 0.8,
                  pointerEvents: 'all',
                }}
                onClick={dateClear}
              />
            ) : null}
            <FiCalendar cursor={'pointer'} size={18 * size} />
          </Flex>
        </Flex>
        {anchor.current && !newDatePicker && (
          <DatePicker
            isCenterOnMobile={isCenterOnMobile}
            show={show}
            selectedDay={selectedDay}
            close={
              show
                ? blur
                : () => {
                    return null
                  }
            }
            onBlur={blur}
            onSubmit={dateChange}
            startDate={value ? value : startDate ? startDate : new Date()}
            anchorEl={anchor}
            onChange={dateChange}
            offsetTop={offsetTop}
            offsetLeft={offsetLeft}
            sizedOnMobile={sizedOnMobile}
            disableMobileResizing={disableMobileResizing}
            startSized={sized}
          />
        )}
        {anchor.current && newDatePicker && (
          <NewDatePicker
            styles={{
              zIndex: 2000,
              ...pickerStyle,
            }}
            anchorEl={anchor.current}
            open={show}
            initialDate={value ? value : startDate ? startDate : new Date()}
            onDateChange={dateChange}
            onClose={
              show
                ? blur
                : () => {
                    return null
                  }
            }
          />
        )}
      </React.Fragment>
    )
  },
)

export default DateInput

export interface IDateInputProps extends IFormElementProps {
  startDate?: Date
  sized?: boolean
  offsetLeft?: number
  offsetTop?: number
  disableMobileResizing?: boolean
  sizedOnMobile?: boolean
  selectedDay?: Date
  isClear?: boolean
  isCenterOnMobile?: boolean
  withEmptyOnStart?: boolean
  isWithError?: boolean
  changeDateOnDisable?: boolean
  newDatePicker?: boolean
  pickerStyle?: CSSProperties
}

export { DateInput }
